'use client';

import { useCallback } from 'react';
import { hubspotAPIClient, type HubSpotContactFormData } from '../../infrastructure/hubspot';
import { debounce } from 'es-toolkit';

const DEBOUNCE_MS = 1000;

export const useHubSpotService = () => {
  const submitContactForm = useCallback(
    debounce(async (data: HubSpotContactFormData) => {
      try {
        await hubspotAPIClient.submitContactForm(data);
      } catch (error) {
        console.error('[HubSpot] Failed to submit contact form:', error);
      }
    }, DEBOUNCE_MS),
    [],
  );

  return {
    submitContactForm,
  };
};
